import React from 'react';
import FormControl from 'react-bootstrap/FormControl';

import RegEx from '../../util/RegEx';
import Display from '../../util/Display';

class FieldMultiValItem extends React.Component {

  constructor(props) {
    super(props);
    this.regex = props.validate;
    this.state = { value: props.value ? props.value : '' };
  }

  handleChange = value => {
    this.setState({ value: value });
    this.props.onChange(this.props.index, value);
  }

  render() {
    let inValid = RegEx.isMatch(this.state.value, false, this.regex);
    if(RegEx.isKeyPresent(this.props.inValid, this.Key)) inValid = false;

    return (
      <div className="form-group">
        <FormControl type="text" value={this.state.value} placeholder={this.props.LabelName}
          onChange={ evt => this.handleChange(evt.target.value) }
          className={`mr-sm-2 ${RegEx.classBool(inValid)}`} />
        { Display.MultiAction(this.props.index, this.props.add, this.props.delete) }
      </div>
    );
  }
}
export default FieldMultiValItem;